// Constantes de domínio do módulo Central de IA.
//
// Ficavam inline nas views — o que reprovava o gate `design-system:no-regression`
// ("Constantes de domínio (OPTIONS/CONFIG/MOCK/EVENT) inline em view detectadas") e,
// mais concreto que a regra: a lista de períodos estava DUPLICADA em `approvals.vue`
// e `executions.vue`, então mudar a janela padrão exigia lembrar das duas.
export const PERIODO_OPTIONS = [
  { text: '7 dias', value: 7 },
  { text: '30 dias', value: 30 },
  { text: '90 dias', value: 90 },
]

// Janela default dos filtros de período (Aprovações e Execuções).
export const DEFAULT_PERIODO = 30

// Valor de "Todos" nos filtros de agente/profissional: `null` significa "sem filtro"
// para o backend — não confundir com `undefined`, que o `formatQueryParams` remove.
export const TODOS_VALUE = null

// Abas de créditos (`modal/creditos-modal` e `views/creditos.vue`, pelo
// `mixins/creditos-abas-mixin.js`). Valores de estado, não copy.
export const CREDITOS_MODAL_ABA = {
  PLANOS: 'planos',
  ADICIONAR: 'adicionar',
  USO: 'uso',
}
export const CREDITOS_ABA_INICIAL = CREDITOS_MODAL_ABA.PLANOS

// Na PÁGINA as três abas são ROTAS (`routes.js`: filhas de `aiFrameworkCreditos`), para
// o header por rota (`ConditionalTeleport`) e para a URL endereçar a aba. O modal segue
// com estado local. Mapa aba → nome de rota; o inverso vive em `utils/creditos-rotas.js`.
export const CREDITOS_ROTA_POR_ABA = {
  [CREDITOS_MODAL_ABA.PLANOS]: 'aiFrameworkCreditosPlanos',
  [CREDITOS_MODAL_ABA.ADICIONAR]: 'aiFrameworkCreditosAdicionar',
  [CREDITOS_MODAL_ABA.USO]: 'aiFrameworkCreditosUso',
}

// Geometria do modal de créditos, compartilhada com a página: a grade de 3 planos, o
// cabeçalho dela, os pacotes e o painel de uso ocupam a MESMA largura útil nos dois
// lugares (no modal é o corpo inteiro; na página, centralizada). O padding lateral tem que
// bater com o `padding` do `.creditos-modal__corpo` (teste em `creditos-modal.unit.js`).
export const CREDITOS_MODAL_LARGURA = 1040
export const CREDITOS_MODAL_PADDING_LATERAL = 32
export const CREDITOS_AREA_UTIL_LARGURA =
  CREDITOS_MODAL_LARGURA - 2 * CREDITOS_MODAL_PADDING_LATERAL

// Aba Uso do modal de créditos (`components/creditos-uso-painel`). Valores de estado do
// toggle de período: dias para trás, ou `ano` (1º de janeiro até hoje). Strings de
// propósito — `BaseToggleButton` tipa `value` como String/Number e um único tipo evita
// comparação frouxa no `isActive`.
export const CREDITOS_USO_PERIODO = {
  DIAS_30: '30',
  DIAS_90: '90',
  ANO: 'ano',
}
export const CREDITOS_USO_PERIODO_PADRAO = CREDITOS_USO_PERIODO.DIAS_30

// Filtro de tipo das movimentações — CLIENT-SIDE sobre o extrato já carregado. `TODAS`
// não é `null`: além do tipo do toggle, `null` no `BaseToggleButton` cai no
// `mandatory` do Vuetify e a pílula "Todas" nunca ficaria ativa. Os demais valores são
// as naturezas do ledger (`CREDITOS_EXTRATO.NATUREZA_LABELS`); ajuste/estorno só
// aparecem em "Todas".
export const CREDITOS_USO_FILTRO = {
  TODAS: 'todas',
  CONSUMO: 'consumo',
  COMPRA: 'compra',
  BONUS: 'bonus',
}

// Linhas exibidas na tabela do painel; o resto fica para "Ver extrato completo".
export const CREDITOS_USO_LINHAS_MAX = 10
// Altura do gráfico "Consumo por dia" na PÁGINA (`larguraTotal`): lá ele ocupa a largura
// inteira e não há coluna de KPIs ao lado para ditar a altura — no modal continua sendo
// a linha do grid quem manda (`height: 100%`).
export const CREDITOS_GRAFICO_ALTURA_PAGINA = 220
// Página única pedida ao extrato: o teto do backend (`usecase_creditos_extrato.LIMITE_MAXIMO`).
// É o que alimenta a tabela E o gráfico por dia — acima disto o período fica parcial.
export const CREDITOS_USO_EXTRATO_LIMIT = 100

// Marcador que o backend põe no `cancel_url` do checkout de ASSINATURA
// (`usecase_creditos_assinatura.py`, `ROTA_CANCELAMENTO`): `?checkout=cancelado`. É o
// único dado que separa quem clicou em "Voltar" na Stripe de quem pagou — as duas
// linhas estão em `aguardando_pagamento`. Mudar aqui exige mudar lá (spec-005 T040).
export const CHECKOUT_QUERY_PARAM = 'checkout'
export const CHECKOUT_CANCELADO = 'cancelado'

// Memória de ONDE o consultor saiu para a Stripe (`utils/retorno-do-checkout.js`): o
// backend devolve para rotas fixas da página de créditos, e quem assinou pelo modal, de
// dentro do chat, precisa voltar para a rota em que estava. `sessionStorage`, com TTL —
// uma sessão de checkout da Stripe expira em 24h, mas uma origem de horas atrás já não
// descreve onde o consultor "estava".
export const CHECKOUT_ORIGEM_STORAGE_KEY = 'aiFramework_checkoutOrigem'
export const CHECKOUT_ORIGEM_TTL_MS = 60 * 60 * 1000
// Superfície de onde o checkout saiu: o modal reabre no retorno; a página não precisa.
export const CHECKOUT_SUPERFICIE = { MODAL: 'modal', PAGINA: 'pagina' }
// Prefixo dos `name` das rotas da página de créditos (`routes.js`: `aiFrameworkCreditos`,
// as três abas e `aiFrameworkCreditosPagamento`) — a nav-bar casa a aba pelo mesmo prefixo.
export const CREDITOS_ROTA_PREFIXO = 'aiFrameworkCreditos'
